import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <Link
      to="/"
      className="group inline-flex items-center"
      data-testid="site-logo-link"
      aria-label="Rozier Concept, retour à l'accueil"
    >
      <img
        src="/images/logo.webp"
        alt="Rozier Concept, Bâti Paysage Énergétique"
        className="h-16 md:h-20 w-auto select-none"
        draggable="false"
      />
    </Link>
  );
};

export default Logo;
